import { browserTelemetryEnabled, reportBrowserError, reportNavigation } from "@/lib/telemetry/browser";
import { startNavigation } from "@/lib/telemetry/browser-navigation";

// Runs in the browser before hydration (see
// node_modules/next/dist/docs/01-app/03-api-reference/03-file-conventions/instrumentation-client.md).
// Conductor telemetry, browser half: uncaught errors, unhandled rejections,
// the page load's timing and the start of client-side navigations. Events go
// to our own POST /api/telemetry (lib/telemetry/browser.ts), never to
// Conductor. Off unless the server marked <html data-telemetry="1">. Kept
// light: listeners only, no work until something happens.

if (browserTelemetryEnabled()) {
  try {
    window.addEventListener("error", (event) => {
      // Resource load errors (an <img> 404) have no `error`: not reported.
      if (event.error === undefined && !event.message) return;
      reportBrowserError(event.error ?? event.message, { handled: false, where: "window" });
    });
    window.addEventListener("unhandledrejection", (event) => {
      reportBrowserError(event.reason, { handled: false, where: "unhandledrejection" });
    });
    window.addEventListener("load", () => {
      // loadEventEnd is set once the load handlers have returned.
      setTimeout(() => {
        const nav = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming | undefined;
        if (nav && nav.loadEventEnd > 0) {
          reportNavigation("browser.pageload", performance.timeOrigin, nav.loadEventEnd);
        }
      }, 0);
    });
  } catch {
    // Never in the page's way.
  }
}

export function onRouterTransitionStart(): void {
  if (browserTelemetryEnabled()) startNavigation();
}
